import { BRAND } from "src/app/config/brand.config";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ResolveEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { Observable, Subscription } from "rxjs";
import { LayoutService } from "../../core/layout.service";
import {
  ToggleComponent,
  ScrollTopComponent,
  DrawerComponent,
  StickyComponent,
  MenuComponent,
  ScrollComponent,
} from "../../../kt/components";
import { PageInfoService } from "../../core/page-info.service";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-scripts-init",
  templateUrl: "./scripts-init.component.html",
  standalone: false,
})
export class ScriptsInitComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];
  constructor(
    private layout: LayoutService,
    private pageInfo: PageInfoService,
    private router: Router,
    private titleService: Title
  ) {
    const initPageInfo = () => {
      setTimeout(() => {
        this.pageInfo.calculateTitle();
        this.pageInfo.calculateBreadcrumbs();
        this.pageInfo.title.asObservable().subscribe((title) => {
          this.titleService.setTitle(BRAND.name + " - " + title);
        });
      }, 10);
    };

    initPageInfo();
    // subscribe to router events
    this.router.events
      .pipe(filter((event) => event instanceof ResolveEnd))
      .subscribe(initPageInfo);
  }

  ngOnInit(): void {
    this.pluginsInitialization();
    const layoutUpdateSubscription = this.layout.layoutConfigSubject
      .asObservable()
      .subscribe(() => {
        this.pluginsReInitialization();
      });
    this.unsubscribe.push(layoutUpdateSubscription);
  }

  pluginsInitialization() {
    setTimeout(() => {
      ToggleComponent.bootstrap();
      ScrollTopComponent.bootstrap();
      DrawerComponent.bootstrap();
      StickyComponent.bootstrap();
      MenuComponent.bootstrap();
      ScrollComponent.bootstrap();
    }, 200);
  }

  pluginsReInitialization() {
    // Was 100ms, independently of LayoutComponent.updateHeader's own 0ms
    // timeout on the same `layoutConfigSubject` emission — the browser had
    // already painted the header once by the time this ran and recomputed
    // the sticky offset, producing a visible second snap on every
    // navigation. Matching the delay puts both DOM-mutating callbacks back
    // to back in the same macrotask flush, before the next paint.
    setTimeout(() => {
      ToggleComponent.reinitialization();
      ScrollTopComponent.reinitialization();
      DrawerComponent.reinitialization();
      StickyComponent.bootstrap();
      MenuComponent.reinitialization();
      ScrollComponent.reinitialization();
    }, 0);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
